import React from 'react';
import styled from 'styled-components';
import logo from '../assets/logo.png';
import Popup from './Popup';
import { useState } from 'react';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #ededed;
  padding: 40px 0 20px;
  position: relative;
  z-index: 1;
  clear: both;
  
  @media (max-width: 479px) {
    padding: 30px 0;
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  position: relative;
  
  @media (max-width: 479px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const LogoSection = styled.div`
  flex: 1;
  min-width: 200px;
`;

const Logo = styled.img`
  width: 200px;
  height: auto;
  margin-bottom: 20px;
`;

const Contacts = styled.div`
  font-size: 18px;
  color: #404040;
  line-height: 1.55;
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  @media (max-width: 479px) {
    font-size: 16px;
  }
`;

const Address = styled.div`
  font-size: 17px;
  color: #404040;
  margin-top: 20px;
  line-height: 1.55;
  
  @media (max-width: 479px) {
    font-size: 15px;
  }
`;

const MenuSection = styled.div`
  flex: 2;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
  
  @media (max-width: 479px) {
    gap: 20px;
  }
`;

const MenuColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const MenuLink = styled.a`
  color: #404040;
  font-size: 18px;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
  
  @media (max-width: 479px) {
    font-size: 16px;
  }
`;

const Copyright = styled.div`
  width: 100%;
  margin-top: 40px;
  color: #a8a8a8;
  font-size: 17px;
  line-height: 1.55;
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  @media (max-width: 479px) {
    font-size: 14px;
    margin-top: 20px;
  }
`;

const Footer = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <FooterContainer>
      <Content>
        <LogoSection>
          <Logo src={logo} alt="Максимум тур" />
          <Contacts>
            <div><a href="tel:+79964269652">+7 (996) 426‒96‒52</a></div>
            <div><a href="tel:+79146579607">+7 (914) 657‒96‒07</a></div>
            <div><a href="tel:+79245200072">+7 (924) 520‒00‒72</a></div>
          </Contacts>
          <Address>
            Владивосток<br />
            Алеутская улица, 45а​<br />
            40 офис, 1 этаж
          </Address>
        </LogoSection>
        
        <MenuSection>
          <MenuColumn>
          <MenuLink as={Link} to="/podbor-tyra?reload=true">Подбор тура</MenuLink>
<MenuLink as={Link} to="/goryashchie-tury?reload=true">Горящие туры</MenuLink>
<MenuLink as={Link} to="/minimalnye-tseny?reload=true">Лечебные туры</MenuLink>
<MenuLink as={Link} to="/strany?reload=true">Страны</MenuLink>

          </MenuColumn>
          
          <MenuColumn>
          <MenuLink as={Link} to="/china">Наши туры в Китай</MenuLink>
<MenuLink as={Link} to="/cruises">Круизы</MenuLink>
<MenuLink as={Link} to="/o-nas">О компании</MenuLink>
<MenuLink as={Link} to="/kontakty">Контакты</MenuLink>
          </MenuColumn>
          
          <MenuColumn>
            <MenuLink onClick={() => setIsPopupOpen(true)}>Заявка на тур</MenuLink>
          </MenuColumn>
        </MenuSection>
        


      




        <Copyright>
          <a href="/">
            2025 © Туристическое агентство "Максимум"<br />
            Предложения на сайте не являются публичной офертой и носят исключительно информационный характер
          </a>
        </Copyright>
      </Content>
      <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />

    </FooterContainer>
  );
};

export default Footer;